import { PublicProfile } from "../people/public-profile.model";
import { BaseRequestModel } from "./base-request.model";

export class OnlinePaymentRequest extends BaseRequestModel {    
    workflowPosition:number = 0;
    profile: PublicProfile;
}

